// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SkillsEvaluation_wrapper__aBej1","skills_wrapper":"SkillsEvaluation_skills_wrapper__1CwTB"};